<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    class="c-menubutton pull-right"
                    color="primary"
                    outlined
                    prepend-inner-icon="mdi-earth"
                    v-bind="attrs"
                    v-on="on"
                    :x-large="$vuetify.breakpoint.mdAndUp"
            >
                <v-icon
                        v-if="$vuetify.breakpoint.lgAndUp"
                        left
                        class="c-menubutton__icon-left"
                >
                    mdi-earth
                </v-icon>
                {{ buttonTitle }}
                <v-icon
                        right
                        dark
                        class="c-menubutton__icon-right"
                >
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
            >
                <v-list-item-title
                    class="c-menubutton__list-item-title"
                    style="cursor: pointer;"
                    v-on="item.listeners"
                    v-bind="item.props">
                    {{ item.title }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>

/**
 * Component MenuButton.vue
 *
 * @module MenuButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/MenuButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MenuButton',
  props: ['buttonTitle', 'items'],
}
</script>

<style lang="scss">
    .v-application .c-menubutton{
        .v-btn__content{
            .c-menubutton__icon-left{
                margin-left: 0;
                margin-right: 15px;
            }
            .c-menubutton__icon-right{
                margin-left: 15px;
            }
        }
    }
    .c-menubutton__list-item-title {
        font-size: 1rem !important;
    }
</style>